import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        canManage: '='
    },
    template: `
        <div class="well color02">
            <div class="heading01 type01">
                <h2>{{ 'user.Inactivity periods' | translate }}</h2>
                <a ng-if="vm.canManageUsers && vm.canManage" class="btn add" ng-click="vm.manageInactivityPeriods()">{{ 'user.Add inactivity period' | translate }}</a>
            </div>
            <ul class="checkboxes mt1em" ng-if="vm.canManage">
                <li>
                    <label uib-tooltip="Overrides active inactivity period">
                        <input type="checkbox" ng-model="vm.checked"><span>{{ 'user.Employee is active' | translate }}</span>
                    </label>
                    <button class="btn bordered02 small" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
            </ul/>
            <list-empty list="vm.user.inactivityPeriods" show-add-message="true"></list-empty>
            <div class="tablewrapper" ng-if="vm.user.inactivityPeriods.length">
                <table class="data01">
                    <thead>
                    <tr>
                        <th>{{ 'user.From' | translate }}</th>
                        <th>{{ 'user.To' | translate }}</th>
                        <th>{{ 'user.Description' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="period in vm.user.inactivityPeriods">
                        <td>{{ vm.MomentService.formatDate(period.start) }}</td>
                        <td>{{ vm.MomentService.formatDate(period.end) }}</td>
                        <td>{{ period.description }}</td>
                        <td class="actions">
                            <a ng-if="vm.canManageUsers && vm.canManage && !period.externalId" class="btn edit" ng-click="vm.manageInactivityPeriods(period.id)">{{ 'general.Edit' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `
})
export default class {
    constructor (ModalService, UserResource, PrivilegeService, MomentService, FormFactory, toastr,
        $translate) {
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.MomentService = MomentService;
        this.canManageUsers = PrivilegeService.canManageUsers();
        this.FormFactory = FormFactory;
        this.checked = false;
        this.toastr = toastr;
        this.$translate = $translate;
    }

    $onInit () {
        this.setIsEmployeeActive();
        this.createForm();
    }

    setIsEmployeeActive () {
        this.checked = this.user.isEmployeeActive;
    }

    createForm () {
        this.form = this.FormFactory.create(this.user, model => model.$update({ id: model.id }));
    }

    beforeSave () {
        this.form.model.isEmployeeActive = this.checked;
    }

    save () {
        this.beforeSave();
        this.form.save()
            .then(() => {
                this.reloadUser();
                this.createForm();
                this.toastr.success(this.$translate.instant('general.Changes saved'));
            });
    }

    manageInactivityPeriods (id) {
        this.reloadUser(); // to avoid cached error values
        const user = this.user;
        return this.ModalService.open({
            template: `
                <modals-user-employee-inactivity-periods on-close="vm.$uibModalInstance.dismiss()" on-update="vm.update()"
                user="vm.user" inactivity-period-id="vm.inactivityPeriodId" class="wrapper"></modals-user-employee-inactivity-periods>
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.user = user;
                this.inactivityPeriodId = id;
                this.update = this.$uibModalInstance.close;
            }
        })
        .then(() => {
            this.reloadUser();
        });
    }

    reloadUser () {
        this.UserResource.get({ id: this.user.id, expand: 'drlsWithValue,inactivityPeriods,drls,anonymizationDate' })
            .$promise.then((reloadedUser) => {
                this.user = reloadedUser;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/inactivityPeriodsList/index.js